import { ModelBase } from '../shared/model.base';

export class App extends ModelBase {
  companyId: number;
  name: '';
  redirectUri: '';
  userId: string;
  isActive: boolean;
  apiKey: '';

  constructor() {
    super();
  }
}
